import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IRoot } from "../../services/interface/IHome";
import FilterComponent from "../../components/FilterComponent";
import PerformanceMetricsTable from "./performanceMetricsTable";
import { useGetPerformaceMatricsTable, useGetPerformaceMatricsChartData, useGetPerformaceMatricsFilters } from "../../services/redux/hooks/useInventory";
import PerformanceMetricsChart from "./performanceMetricsChart";
import moment from "moment";
import { Button } from "rsuite";
import reload from "../../assets/reload.svg";
import upArrow from "../../assets/uparrowFilter.svg";
import downArrow from "../../assets/downarrowFilter.svg";
import CustomLoader from "../../common/CustomLoader/CustomLoader";

const baseFilters = {
  pc: [],
  priceLine: [],
  sku: [],
};


const PerformanceMatrics = () => {
const [isVisible, setIsVisible] = useState<boolean>(true);
const [tableData, setTableData] = useState([]);
const [totalRowData, setTotalRowData] = useState([]);
const [chartData, setChartData] = useState([]);
const [fullChartData, setFullChartData] = useState<any>([]);
const [loading, setLoading] = useState(false);
const [viewBy, setViewBy] = useState('priceLine');
const [selectedRow, setSelectedRow] = useState<string | null>(null);
const [selectedRowLevel, setSelectedRowLevel] = useState<string | null>(null);

  const lastUpdated =
    useSelector((state: IRoot) => state.filter.lastUpdateDate) || "";

const { mutate: mutatePMTable, isLoading: isTableLoading, isSuccess, data: pmData } =
  useGetPerformaceMatricsTable();
const { mutate: triggerFilters, isLoading: isFiltersLoading } =
  useGetPerformaceMatricsFilters();
const { mutate: mutatePMChart, isLoading: isChartLoading } =
  useGetPerformaceMatricsChartData();

const initialState:{[key:string]:string[]} = {
    pc: [],
    priceLine: [],
    sku: [],
  }
  const [filters, setFilters] = useState<any>({
    pc: [],
    priceLine: [],
    sku: [],
  });

  const [selectedFilterData, setSelectedFilterData] = useState<{
    [key: string]: string[];
  }>(initialState);


 const fetchFilters = async () => {
    try {
      // Create payload using selectedFilterData
      const payload: any = {
        filters: {
                PC: selectedFilterData.pc ?? [],
                PriceLine: selectedFilterData.priceLine ?? [],
                SKU: selectedFilterData.sku ?? [],
            },
      };

      const response = await triggerFilters(payload).unwrap();
      setFilters(response);
    } catch (error) {
      console.error("Error fetching filters:", error);
    }
  };

useEffect(() => {
    fetchFilters();
}, [selectedFilterData]);

  // Handle filter change
  const handleFilterChange = (filterKey: string, values: string[]) => {
    setSelectedFilterData((prevState) => ({
      ...prevState,
      [filterKey]: values,
    }));
  };

   const handleApply = () => {
    // Convert selectedFilterData to match baseFilters structure
    const filterPayload = {
      ...baseFilters,
      ...selectedFilterData,
    };
    fetchGraphDataWithFilters(filterPayload);
    let payload = { filters: {
              PC: filterPayload.pc,
              PriceLine: filterPayload.priceLine,
              SKU: filterPayload.sku
          },}
    mutatePMTable(payload);
  };
  // Handle clear filters
  const handleClear = () => {
    setSelectedFilterData({}); 
    fetchFilters();
    fetchGraphDataWithFilters(baseFilters);
     let payload = { filters: {
              PC: [],
              PriceLine: [],
              SKU: [],
          },}
    mutatePMTable(payload);
  };

    const fetchGraphDataWithFilters = async (filterPayload: any) => {
       let payload = { filters: {
                PC: filterPayload.pc,
                PriceLine: filterPayload.priceLine,
                SKU: filterPayload.sku
            },}
    try {
      const response = await mutatePMChart(payload).unwrap();

      if (response) {
        setChartData(response[viewBy]?.points)
        setFullChartData(response);        
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

    // Initial data fetch
    useEffect(() => {
      fetchGraphDataWithFilters(baseFilters);
    }, []);

    useEffect(() => {
        let filterPayload:any = {
        ...baseFilters,
        ...selectedFilterData,
        };
        if(selectedRowLevel && selectedRowLevel != '' && selectedRowLevel != 'Overall'){
           filterPayload[selectedRowLevel] = [...filterPayload[selectedRowLevel],selectedRow];
        }
        fetchGraphDataWithFilters(filterPayload);
    }, [selectedRow]);


useEffect(() => {
    const payload = {
      filters: {
        PC: [],
        PriceLine: [],
        SKU: [],
      },
    };
  mutatePMTable(payload);

}, []);

 useEffect(() => {
        setLoading(true);
        if (pmData) {
            let newData:any = [];
            newData.push({
                group:'Overall',
                viewLevel:'Overall',
                devaluedQty: pmData?.overall?.devaluedQty,
                gmroi: pmData?.overall?.gmroi,
                grossProfitPct: pmData?.overall?.grossProfitPct,
                nonStockQty: pmData?.overall?.nonStockQty,
                onHandQty: pmData?.overall?.onHandQty,
                turns: pmData?.overall?.turns,
            })
            pmData?.overall?.children.map((item:any)=>{
                newData.push(item);
            })
            let finalData = JSON.parse(JSON.stringify(newData));
            finalData?.map((item:any)=>{
                
                if(item.group != 'Overall'){
                    item.items.map((i:any)=>{
                        i.viewLevel = item.group == "PC" ? 'pc': item.group == "PriceLine"? 'priceLine': item.group == "SKU" ? 'sku' :item.group;
                    })
                }
            })
            console.log('##',finalData);
            
            setTableData(finalData);
            
            setTotalRowData(pmData?.Total);
        }
        if (isSuccess) {
            setLoading(false);
        }
}, [pmData]);

 useEffect(() => {
    if (fullChartData) {
        let newData:any = fullChartData[viewBy]?.points;
        setChartData(newData);
    }
}, [viewBy]);

  const filterShowHandler = () => {
    setIsVisible(!isVisible);
  };

    // Map current view tab to API filter key
  const keyByView: Record<string, 'PC' | 'PriceLine' | 'SKU'> = {
    pc: 'PC',
    priceLine: 'PriceLine',
    sku: 'SKU',
  };
    const handleChartPointClick = (point: any) => {
    const id = point?.id;
    if (!id) return;
    const filterKey = keyByView[viewBy] || 'SKU';
    const payload = {
      filters: {
        PC: [],
        PriceLine: [],
        SKU: [],
        [filterKey]: [String(id)],
      },
    };
    mutatePMTable(payload);
  };
const anyLoading = isTableLoading || isChartLoading || isFiltersLoading;

  return (
    <>
      <div className="relative">
          <div
                  className={`flex flex-col gap-1 px-[2%] border-b-[1px] shadow ${
                    !isVisible ? "pt-[8px] pb-[2px]" : "pt-[8px] pb-[15px]"
                  }`}
                >
                  <div className="flex justify-between items-center mb-1">
                    <h3 className="page-title font-semibold">{"Inventory Ops Performance"}</h3>
                    {
                      <div className="flex gap-2">
                        <img src={reload} alt="reload" className="w-[1vw]" />
                        <p className="text-fs16 text-[#858585] font-semibold">
                          Last Updated :{" "}
                          <span>
                            {moment(lastUpdated?.slice(0, 10)).format("M/DD/YYYY")}
                          </span>
                        </p>
                      </div>
                    }
                  </div>
        
                  {/* Filters Section */}
                  {isVisible && (
                    <div className="grid grid-cols-[1fr_auto] items-end gap-4 filter-div">
                      <div className="grid grid-cols-12 gap-2 items-end">
                      {filters && Object.entries(filters).map(([filterKey, filterData]) => {
                      if (filterKey === "ucode" || !Array.isArray(filterData)) {
                        return null;
                      }
        
                      // Filter out null values only for productSegm
                      const filteredData = filterKey === "productSegm" 
                        ? filterData.filter(filter => filter.filterVal !== null && filter.filterVal !== "null")
                        : filterData;
        
                      return (
                        <FilterComponent
                          loading={isFiltersLoading}
                          key={filterKey}
                          filterKey={filterKey}
                          filterName={
                            filterKey === "pc"
                              ? "PC"
                              : filterKey === "priceLine"
                              ? "Price Line"
                              : filterKey === "sku"
                              ? "SKU"
                              : filterKey.charAt(0).toUpperCase() + filterKey.slice(1)
                          }
                          options={filteredData.map((filter: {
                            label: string;
                            value : string;
                          }) => ({
                            label: filter.label,
                            value: filter.value,
                          }))}
                          labelKey="label"
                          valueKey="value"
                          value={selectedFilterData[filterKey] || []}
                          onFilterChange={handleFilterChange}
                        />
                      );
                    })}
        
                      </div>
                      <div className="align-right flex gap-1">
                        <Button
                          onClick={handleClear}
                          disabled={anyLoading}
                          className="bg-[#949494] text-white px-[20px] h-[4vh] rounded font-semibold btn-text"
                        >
                          Clear
                        </Button>
                        <Button
                          onClick={handleApply}
                          disabled={anyLoading}
                          className="bg-deloitteGreen text-white px-[20px] h-[4vh] rounded font-semibold btn-text"
                        >
                          Apply
                        </Button>
                      </div>
                    </div>
                  )}
        
                  <div
                    className="flex justify-center absolute left-2/4 top-full translate-x-[-50%] translate-y-[-50%] cursor-pointer z-[10]"
                    onClick={filterShowHandler}
                  >
                    {isVisible && (
                      <img className="w-[1.5vw]" src={upArrow} alt="upArrow" />
                    )}
                    {!isVisible && (
                      <img className="w-[1.5vw]" src={downArrow} alt="downArrow" />
                    )}
                  </div>
                </div>
      </div>
      <div className="bg-[#F1F1F1] h-full flex h-full gap-4 flex-grow overflow-hidden px-[2%] py-3">
        <div className="flex items-start justify-center gap-4 w-[50%]">
          <PerformanceMetricsTable
            data={tableData}
            totalRowData = {totalRowData}
            loading={loading}
            selectedRow={selectedRow}
            updateSelectedRow={(value:any)=>{setSelectedRow(value)}}
            updateSelectedRowLevel={(value:any)=>{setSelectedRowLevel(value)}}
            onSelectCategory={() => {}}
          />
        </div>
        <div className="flex flex-col items-start justify-center gap-4 w-[50%] bg-[#FFF] shadow rounded px-[2%] py-[10px] border-[1px] border-[#BEBEBE] flex flex-col grow">
        
          <div className="flex w-full justify-between items-center mb-[0.25vw]">
                <span className="text-mainGreen font-semibold chart-title self-start">
                    {'GM vs Turns'}
                </span>
                <div className="flex gap-x-[1vh]">
                    <div className={`${viewBy == 'pc'? 'bg-deloitteGreen': 'bg-[#949494]'} cursor-pointer flex justify-center chart-title items-center text-white px-[20px] min-w-[7vw] h-[4vh] rounded font-semibold btn-text`}
                    onClick={()=>{setViewBy('pc')}}
                    >
                            PC
                    </div>
                    <div className={`${viewBy == 'priceLine'? 'bg-deloitteGreen': 'bg-[#949494]'} cursor-pointer flex justify-center chart-title items-center text-white min-w-[7vw] px-[20px] h-[4vh] rounded font-semibold btn-text`}
                    onClick={()=>{setViewBy('priceLine')}}
                    >
                            Price Line
                    </div>
                    {/* <div className={`${viewBy == 'sku'? 'bg-deloitteGreen': 'bg-[#949494]'} cursor-pointer flex justify-center items-center text-white w-[7vw] px-[20px] h-[4vh] rounded font-semibold btn-text`}
                    onClick={()=>{setViewBy('sku')}}
                    >
                            SKU
                    </div> */}
                </div>
            </div>
            {isChartLoading ? 
                <div className="flex justify-center items-center p-3 text-center text-black w-full h-full">
                    Loading...
                </div>
            :
            <PerformanceMetricsChart
                title="GM vs Turns"
                data={chartData}
                refX={0}
                refY={0}
                onPointClick={handleChartPointClick}
            />
            }

          {anyLoading && <CustomLoader open={anyLoading} />}
        </div>
      </div> 
    </>
  );
};

export default PerformanceMatrics;
